export default __webpack_public_path__ + "static/saleHr-89588178994de5464a553c458c581358.svg";